import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate';

export default createStore({
  state: {
    role: null,
    user: {
      status: null,
    },
  },
  getters: {
    isEngineer(state) {
      console.log(state.role);
      return state.role === 1;
    },
    isIntegrator(state) {
      console.log(state.role);
      return state.role === 2;
    },
  },
  mutations: {
    updateRole(state, newRole) {
      state.role = newRole;
    },
    updateUser(state, info) {
      state.user = info;
    },
  },
  actions: {
    setRoleOnLogin({ commit }, role) {
      commit('updateRole', role);
    },
    setUser({ commit }, info) {
      commit('updateUser', info);
    },
  },
  modules: {
  },
  plugins: [createPersistedState()],
})
